import React from 'react';
import { useCurator } from '@noths/curator-web';
import dynamic from 'next/dynamic';

import { isProd } from 'src/environment';

const Curator = dynamic(
  () =>
    import('@noths/curator-web').then(async (m) => {
      m.configureCurator({
        env: isProd() ? 'production' : 'qa',
        hideChatToggleForMobileViewport: true,
      });
      return m.Curator;
    }),
  { ssr: false },
);

export const CuratorWrapper = () => {
  const { handleToggle, isCuratorOpen, redirectToPDP } = useCurator();

  return (
    <Curator
      isOpen={isCuratorOpen}
      onProductClick={redirectToPDP}
      onToggle={handleToggle}
      showFavourties
    />
  );
};
